import { Persona } from './persona';
import { TipoGenericoRimovibile } from './tipologiche/tipo-generico-rimovibile';

export class ParteReato {
  tipoParteReato: TipoGenericoRimovibile;
  persona: Persona;
  idParent: string;
  categoria: string;
}
